import { FormControl, Grid, IconButton } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import { Add, Delete } from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import * as React from "react";

interface IProps {
    addMedication: any,
    defaultMedication: string,
    handleMedicationOrVitaminName: any,
    medications: any[],
    medicationList: any[],
    removeMedication: any,
    showFakeOutOption: boolean
}

class MedicationSelection extends React.Component<IProps, any> {

    constructor(props: IProps) {
        super(props);
    }

    public handleAutocompleteChange = (index: number) => (event: any, newValue: any) => {
        const syntheticEvent = {
            target: {
                value: newValue ? newValue.drugId : ''
            }
        };
        this.props.handleMedicationOrVitaminName(syntheticEvent, index);
    };

    public render() {
        return (
            <Grid item xs>
                {this.props.medicationList.map((value, index) =>
                    <div key={index} style={{marginTop: 10}}>
                        <FormControl>
                            <Autocomplete
                                value={this.props.medications.find(
                                    med => med.drugId === this.props.medicationList[index]
                                ) || null}
                                options={this.props.medications}
                                getOptionLabel={(option) => option ? option.description : ""}
                                style={{width: 325}}
                                classes={{
                                    root: 'MuiFormControl-root'
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Medications or Vitamins (Optional)"
                                        variant="outlined"
                                        placeholder="Start typing to filter..."
                                    />
                                )}
                                onChange={this.handleAutocompleteChange(index)}
                                filterOptions={(options, { inputValue }) => {
                                    return options.filter((option) =>
                                        option.description.toLowerCase().includes(inputValue.toLowerCase())
                                    );
                                }}
                            />
                        </FormControl>
                    </div>
                )}

                <div>
                    <IconButton color="primary" aria-label="add medication" onClick={this.props.addMedication}>
                        <Add />
                    </IconButton>
                    <IconButton color="primary" aria-label="delete medication" onClick={this.props.removeMedication}>
                        <Delete />
                    </IconButton>
                </div>
            </Grid>
        )
    }
}

export default MedicationSelection